import { useSelector } from "react-redux";

interface PermissionsSlice {
  tokenPermissions: string[];
  roles: string[];
}

const useReduxSelector = () =>
  useSelector<any, PermissionsSlice>((state) => ({
    tokenPermissions: state.authenticatedViewReducer.tokenPermissions,
    roles: state.authenticatedViewReducer.roles,
  }));

const useTokenPermissions = (permissionRequired: string): boolean => {
  const { tokenPermissions } = useReduxSelector();

  return tokenPermissions.includes(permissionRequired);
};

const useTokenAnyPermissions = (permissionRequired: string[]): boolean => {
  const { tokenPermissions } = useReduxSelector();

  return tokenPermissions.some((permission) =>
    permissionRequired.includes(permission)
  );
};

const useTokenRoles = (rolRequired: string): boolean => {
  const { roles } = useReduxSelector();

  return roles.includes(rolRequired);
};

export { useTokenPermissions, useTokenAnyPermissions, useTokenRoles };
